import { roundNumberAndDecimals } from '@teinor/erp/prices'
import { totalCalculateParams } from '@teinor/erp/prices/quote/calculate'
import { relatedTypesInversed } from '@teinor/erp/types/company/config/paymentType'
import { useCallback, useEffect, useState } from 'react'
import { ButtonPrimary, ButtonSecondary } from '../../../../../../../../baseComponents/Button'
import { ModalMediumCenteredLoading } from '../../../../../../../../baseComponents/Modal'
import TwinIcon from '../../../../../../../../baseComponents/TwinIcon'
import { RowData } from '../../../../../../../../baseComponents/TwinTable/types'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import { InputHidden } from '../../../../../../../../forms/Input'
import { RectangularInputPrice } from '../../../../../../../../forms/Input/InputPrice'
import TextArea from '../../../../../../../../forms/Input/TextArea'
import TwinForm from '../../../../../../../../forms/TwinForm'
import { BeforeSubmitHandler } from '../../../../../../../../forms/TwinForm/types'
import CustomInputTotalsTablePriceTPV from '../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/components/CustomInputTotalsTable'
import { twinFetchPostJSON } from '../../../../../../../../utils/globals/data'
import { dictionaryComplexFromJsonArr, TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import { SetEditDeleteModalTy } from '../../../../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { dictIcon } from '../../../../../../../../utils/icons'
import { getPaymentTypes } from '../../../../../../../../utils/reducers/getters'
import { MyPaymentsCashInOutTy, MyTotalPaymentsTypesCashInOut, PaymentTypeModelAddExtended } from '../../../types'
import '../modalMoneyCashInOutTPVDSB.sass'


type ModalMoneyCashInOutProps = ModalMoneyCashInOutLogicProps & {
}

const ModalMoneyCashInOut: React.FC<ModalMoneyCashInOutProps> = ({ setOpenModal, ...logic }) => {
    const { t } = useTwinTranslation()
    const { handleBeforeSubmit, myPaymentMethodsTypes, handleChangeField, myTotalPaymentsTypes } = useModalMoneyCashInOutLogic({ setOpenModal, ...logic })
    const renderThis: JSX.Element[] = []
    let isDisabled = true
    for (const key in myPaymentMethodsTypes || []) {
        const element = myPaymentMethodsTypes?.[key]
        if (element) {
            if (element.assigned) {
                isDisabled = false
            }
            renderThis.push(<PaymentMethodsTypesBox element={element} rowIndex={parseInt(key)} handleChangeField={handleChangeField} key={key} myTotalPaymentsTypes={myTotalPaymentsTypes || null} />)
        }
    }
    const titleDict: TwinDictionary = {
        'cashIn': t('cashIn', 'Entrada de caja'),
        'cashOut': t('cashOut', 'Salida de caja'),
    }
    return (
        <ModalMediumCenteredLoading loading={myPaymentMethodsTypes?.length ? false : true} className='modal_cash_in_out flex_height' opened={true} setOpened={() => setOpenModal(null)} onClickOut={true}>
            <h2 className='mt-20'>{titleDict[logic?.allRowData?.action]}</h2>
            <TwinForm action={''} onSubmit={() => {}} className='mt-20 flex flex-auto flex-col notFlexAutoFormRender' beforeSubmitHandler={handleBeforeSubmit}>
                <div className='flex flex-col flex-auto gap-10 px-30'>
                    {renderThis}
                </div>
                <div className='flex w-full mt-10 px-30'>
                    <TextArea label={t('notes', 'Notas')} name='notes' />
                </div>
                <MoneyCashTotals {...{ setOpenModal, myPaymentMethodsTypes: myPaymentMethodsTypes || null, myTotalPaymentsTypes: myTotalPaymentsTypes || null, disabled: isDisabled}} />
            </TwinForm>
        </ModalMediumCenteredLoading>
    )
}

interface ModalMoneyCashInOutLogicProps {
    allRowData?: RowData
    setOpenModal: SetEditDeleteModalTy
}

const useModalMoneyCashInOutLogic = ({ setOpenModal, allRowData }: ModalMoneyCashInOutLogicProps) => {
    const [myPayments, setMyPayments] = useState<MyPaymentsCashInOutTy | null>(null)
    const paymentTypes = getPaymentTypes()

    const handleBeforeSubmit: BeforeSubmitHandler = useCallback((vals) => {
        vals.CashRegisterId = allRowData?.CashRegisterId
        const myPaymentMethodInfo = []
        for (const element of myPayments?.myPaymentMethodsTypes || []) {
            const myQuantity = roundNumberAndDecimals(element.quantity, totalCalculateParams)
            if (myQuantity) {
                if (allRowData?.action === 'cashOut') {
                    element.quantity = myQuantity * -1
                }
                myPaymentMethodInfo.push({ ...element, payment_data: vals.notes })
            }
        }
        vals.paymentMethodInfo = myPaymentMethodInfo
        vals.action = allRowData?.action
        if (myPayments?.myTotalPaymentsTypes?.errors) {
            vals.errors = myPayments.myTotalPaymentsTypes.errors
        }
        setOpenModal({ type: 'create', allRowData: vals })
        return false
    }, [allRowData, myPayments?.myPaymentMethodsTypes, setOpenModal, myPayments?.myTotalPaymentsTypes?.errors])
    
    const getTPVPaymentTypes = useCallback(async () => {
        if (paymentTypes?.activeTpv) {
            const myResult: PaymentTypeModelAddExtended[] = []
            for (const key in paymentTypes?.activeTpv || []) {
                const element = paymentTypes?.activeTpv?.[parseInt(key)]
                if (element.relatedType === relatedTypesInversed['cash']) {
                    myResult.push({
                        ...element,
                        PaymentTypeId: element.id,
                        quantity: 0,
                        assigned: false
                    })
                }
            }
            const totalsResult = await twinFetchPostJSON('/api/app/order/tpv/cashRegister/cashRegisterMoney/getAllCashRegisterMoneysCash', { where: { CashRegisterId: allRowData?.CashRegisterId } })
            setMyPayments((old) => {
                const copyOld = JSON.parse(JSON.stringify(old || {}))
                copyOld.myTotalPaymentsTypes = { ...dictionaryComplexFromJsonArr(totalsResult, 'PaymentTypeId'), errors: null }
                copyOld.myPaymentMethodsTypes = myResult
                return copyOld
            })
        }
    }, [setMyPayments, allRowData?.CashRegisterId, paymentTypes?.activeTpv])

    const handleChangeTotals = useCallback((PaymentTypeId: number, value: any) => {
        setMyPayments((old) => {
            const copy = JSON.parse(JSON.stringify(old))
            if (copy.myTotalPaymentsTypes[PaymentTypeId]) {
                const myValue = allRowData?.action === 'cashIn' ? parseFloat(String(value)) : (parseFloat(String(value)) * -1)
                copy.myTotalPaymentsTypes[PaymentTypeId]['totalRest'] = parseFloat(String(copy.myTotalPaymentsTypes[PaymentTypeId].money)) + myValue
                if (allRowData?.action === 'cashOut') {
                    if (copy.myTotalPaymentsTypes[PaymentTypeId]?.['totalRest'] < 0) {
                        if (!copy.myTotalPaymentsTypes['errors']) {
                            copy.myTotalPaymentsTypes['errors']= {}
                        }
                        copy.myTotalPaymentsTypes['errors'][PaymentTypeId] = true
                    } else {
                        if (copy.myTotalPaymentsTypes['errors']?.[PaymentTypeId]) {
                            delete copy.myTotalPaymentsTypes['errors'][PaymentTypeId]
                            if (!Object.keys(copy.myTotalPaymentsTypes['errors']).length) {
                                copy.myTotalPaymentsTypes['errors'] = null
                            }
                        }
                    }
                }
            }
            return copy
        })
    }, [setMyPayments, allRowData?.action])

    const handleChangeField = useCallback((pos: number, field: string, value: any) => {
        setMyPayments((old) => {
            const copy = JSON.parse(JSON.stringify(old))
            if (copy.myPaymentMethodsTypes) {
                let myValue = value
                if (field === 'quantity') {
                    myValue = parseFloat(String(value)) ? value : 0
                    copy.myPaymentMethodsTypes[pos]['assigned'] = myValue ? true : false
                    handleChangeTotals(copy.myPaymentMethodsTypes[pos].id, myValue)
                }
                copy.myPaymentMethodsTypes[pos][field] = value
            }
            return copy
        })
    }, [setMyPayments, handleChangeTotals])

    useEffect(() => {
        getTPVPaymentTypes()
    }, [getTPVPaymentTypes])

    return { handleBeforeSubmit, myPaymentMethodsTypes: myPayments?.myPaymentMethodsTypes, handleChangeField, myTotalPaymentsTypes: myPayments?.myTotalPaymentsTypes }
}

interface PaymentMethodsTypesBoxProps {
    element: PaymentTypeModelAddExtended
    rowIndex: number
    handleChangeField: (pos: number, field: string, value: any) => void
    myTotalPaymentsTypes: MyTotalPaymentsTypesCashInOut | null
}

const PaymentMethodsTypesBox: React.FC<PaymentMethodsTypesBoxProps> = ({ element, rowIndex, handleChangeField, myTotalPaymentsTypes }) => {
    const myCurrencyId = element?.extraData?.CurrencyId
    const borderColor = element.assigned ? (myTotalPaymentsTypes?.errors?.[element.PaymentTypeId || 0] ? 'border_red' : 'border-green-43') : 'border-gray-D6'
    const iconColor = element.assigned ? (myTotalPaymentsTypes?.errors?.[element.PaymentTypeId || 0] ? 'color_red' : 'text-green-21') : 'text-gray-63'
    return (
        <div className={'py-15 px-30 border payment_box flex w-full flex-col ' + borderColor}>
            <div className='flex'>
                <div className='flex flex-auto items-center'>
                    <TwinIcon icon={dictIcon[element.icon || 'faMoneyBill']} className={'mr-8 regular20 flex w-24 h-24 ' + iconColor} />
                    <span className='regular16'>
                        {element.name}
                    </span>
                </div>
                <RectangularInputPrice label={''} CurrencyId={myCurrencyId} onChange={(value) => handleChangeField(rowIndex, 'quantity', value)} value={element.quantity} className='justify-end flex w-150' />
            </div>
            <InputHidden name='PaymentTypeId' value={element.id} />
        </div>
    )
}


interface MoneyCashTotalsProps {
    setOpenModal: SetEditDeleteModalTy
    myPaymentMethodsTypes: PaymentTypeModelAddExtended[] | null
    myTotalPaymentsTypes: MyTotalPaymentsTypesCashInOut | null
    disabled: boolean
}

const MoneyCashTotals: React.FC<MoneyCashTotalsProps> = ({ setOpenModal, myPaymentMethodsTypes, myTotalPaymentsTypes, disabled }) => {
    const renderThis: JSX.Element[] = []
    for (const element of myPaymentMethodsTypes || []) {
        if (element.id) {
            const textColor = myTotalPaymentsTypes?.errors?.[element.PaymentTypeId || 0] ? 'color_red' : 'text-gray-63'
            const myTotal = (myTotalPaymentsTypes?.[element.id]?.totalRest || myTotalPaymentsTypes?.[element.id]?.totalRest === 0) ? myTotalPaymentsTypes?.[element.id]?.totalRest : (myTotalPaymentsTypes?.[element.id]?.money || 0)
            renderThis.push(<CustomInputTotalsTablePriceTPV currency={element?.extraData?.CurrencyId || 'EUR'} inputName={element.name + ':'} value={parseFloat(String(myTotal))} className='medium14' classNameValue={'regular22 ' + textColor} />)
        }
    }
    return (
        <div className='flex mt-20 bg-gray-FB payment_footer'>
            <div className='flex flex-col flex-auto payment_footer_totals'>
                {renderThis}
            </div>
            <div className='flex items-center gap-x-10 justify-end flex-auto mt-auto'>
                <ButtonSecondary onClick={() => setOpenModal(null)} className=''>
                    <TwinTrans transKey='cancel'>Cancelar</TwinTrans>
                </ButtonSecondary>
                <ButtonPrimary disabled={disabled}><TwinTrans transKey='accept'>Aceptar</TwinTrans></ButtonPrimary>
            </div>
        </div>
    )
}

export default ModalMoneyCashInOut